import { useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import {
    GetVideoInterviewData,
    UploadInterviewVideo,
    isVideoUploadError,
} from "../infrastructure/videoInterviewService";

export function useVideoInterview(token: string | undefined) {
    return useQuery({
        queryKey: ["videoInterview", token],
        queryFn: () => GetVideoInterviewData(token!),
        enabled: !!token,
        staleTime: 5 * 60 * 1000,
    });
}

export function useUploadVideo(token: string) {
    const [uploadProgress, setUploadProgress] = useState(0);

    const mutation = useMutation({
        mutationFn: ({ videoBlob, captchaToken }: { videoBlob: Blob; captchaToken?: string }) => {
            setUploadProgress(0);
            return UploadInterviewVideo(token, videoBlob, captchaToken, setUploadProgress);
        },
        onError: (error) => {
            if (isVideoUploadError(error)) {
                toast.error(error.message);
            }
        },
    });

    return { ...mutation, uploadProgress };
}
